<template>
    <section class="goods-top-menu">
        <div>
            <b-nav tabs ref="topMenu">
                <b-nav-item :to="{name: 'user'}" :active="this.$router.currentRoute.name == 'user'">Пользователи</b-nav-item>
                <b-nav-item :to="{name: 'roles'}" :active="this.$router.currentRoute.name == 'roles'">Группы пользователей</b-nav-item>
                <b-nav-item :to="{name: 'control'}" :active="this.$router.currentRoute.name == 'control'">Контроль</b-nav-item>
            </b-nav>
        </div>
    </section>
</template>

<script>
    export default {
        name: "userTopMenu"
    }
</script>

<style scoped>
    .goods-top-menu {
        margin-bottom: 20px;
    }
</style>